import { Typography } from '@mui/material';

function Required() {
  return (
    <Typography variant="inherit" color="red" component="span">
      {' '}
      *
    </Typography>
  );
}

export default Required;
